import { render, staticRenderFns } from "./BaseSettingAdd.vue?vue&type=template&id=a4ea2fe2&"
import script from "./BaseSettingAdd.vue?vue&type=script&lang=js&"
export * from "./BaseSettingAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports